import { NetworkError } from '@jet-app/music-classical/utilities';
import type { SeeAllPageIntent } from './SeeAllPageIntent';
import type { IntentController } from '@jet/environment/dispatching';
import type { ObjectGraph } from '@jet/environment/dependencies';
import type { SeeAllPage } from '@jet-app/music-classical/models/pages/see-all';
import { IntentKind } from '@jet-app/music-classical/intents';
import { renderSeeAllPage } from './renderSeeAllPage';
import { requestViewPageWithQuery } from '@jet-app/music-classical/api/request-view-page';

export const SeeAllPageIntentController: IntentController<SeeAllPageIntent> = {
    $intentKind: IntentKind.SEE_ALL_PAGE,

    async perform(
        intent: SeeAllPageIntent,
        objectGraph: ObjectGraph,
    ): Promise<SeeAllPage> {
        const apiResponse = await requestViewPageWithQuery(
            `${intent.query}`,
            objectGraph,
        );

        if (!apiResponse?.body) {
            throw NetworkError.noContent();
        }

        return renderSeeAllPage(apiResponse, objectGraph);
    },
};
